var _rect, _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClipDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 85,
    viewBox: "0 0 150 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 84.7222,
    fill: "#EEF5FF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 42,
    r: 32,
    fill: "#DAE9FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.707 41.8139V36.3911H85.8654V41.8139",
    stroke: "#91C0DB",
    strokeWidth: 1.35744,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5447 35.6962L75.5447 31.3608",
    stroke: "#91C0DB",
    strokeWidth: 1.35744,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7155 23.001H63.5426C63.0137 23.001 62.585 23.4297 62.585 23.9586V29.7044C62.585 30.2332 63.0137 30.662 63.5426 30.662H89.7155C90.2444 30.662 90.6732 30.2332 90.6732 29.7044V23.9586C90.6732 23.4297 90.2444 23.001 89.7155 23.001Z",
    fill: "#ACCFE6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6734 23.9576V29.7018C90.6734 29.9557 90.5725 30.1993 90.3929 30.3789C90.2133 30.5585 89.9697 30.6594 89.7158 30.6594H81.7361V23H89.7158C89.9696 23.0004 90.2129 23.1015 90.3924 23.281C90.5719 23.4605 90.673 23.7038 90.6734 23.9576Z",
    fill: "#90C1F3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6828 28.2664C87.4761 28.2664 88.1192 27.6233 88.1192 26.83C88.1192 26.0367 87.4761 25.3936 86.6828 25.3936C85.8895 25.3936 85.2463 26.0367 85.2463 26.83C85.2463 27.6233 85.8895 28.2664 86.6828 28.2664Z",
    fill: "#B2DBF7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1191 26.83C88.1191 27.0186 88.0819 27.2053 88.0097 27.3795C87.9375 27.5537 87.8317 27.7119 87.6983 27.8452C87.5649 27.9784 87.4065 28.0841 87.2323 28.1561C87.058 28.2281 86.8712 28.2651 86.6827 28.2648C86.5476 28.2659 86.4132 28.2466 86.2839 28.2076C86.5828 28.1213 86.8455 27.9402 87.0324 27.6916C87.2194 27.4429 87.3205 27.1403 87.3205 26.8292C87.3205 26.5181 87.2194 26.2155 87.0324 25.9669C86.8455 25.7183 86.5828 25.5371 86.2839 25.4508C86.4132 25.4118 86.5476 25.3925 86.6827 25.3936C86.8714 25.3934 87.0583 25.4304 87.2326 25.5025C87.407 25.5746 87.5654 25.6804 87.6989 25.8138C87.8323 25.9473 87.9381 26.1057 88.0102 26.2801C88.0823 26.4545 88.1193 26.6413 88.1191 26.83Z",
    fill: "#91C0DB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6737 23.9576V29.7018C90.6737 29.9557 90.5728 30.1993 90.3932 30.3789C90.2137 30.5585 89.9701 30.6594 89.7161 30.6594H88.2797C88.5336 30.6594 88.7772 30.5585 88.9568 30.3789C89.1364 30.1993 89.2373 29.9557 89.2373 29.7018V23.9576C89.2369 23.7038 89.1358 23.4605 88.9563 23.281C88.7768 23.1015 88.5335 23.0004 88.2797 23H89.7161C89.9699 23.0004 90.2133 23.1015 90.3928 23.281C90.5723 23.4605 90.6733 23.7038 90.6737 23.9576Z",
    fill: "#E2F2FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7155 23.001H63.5426C63.0137 23.001 62.585 23.4297 62.585 23.9586V29.7044C62.585 30.2332 63.0137 30.662 63.5426 30.662H89.7155C90.2444 30.662 90.6732 30.2332 90.6732 29.7044V23.9586C90.6732 23.4297 90.2444 23.001 89.7155 23.001Z",
    stroke: "#579EE5",
    strokeWidth: 0.638962,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6828 28.2664C87.4761 28.2664 88.1192 27.6233 88.1192 26.83C88.1192 26.0367 87.4761 25.3936 86.6828 25.3936C85.8895 25.3936 85.2463 26.0367 85.2463 26.83C85.2463 27.6233 85.8895 28.2664 86.6828 28.2664Z",
    stroke: "#579EE5",
    strokeWidth: 0.638962,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6734 23.9576V29.7018C90.6734 29.9557 90.5725 30.1993 90.3929 30.3789C90.2133 30.5585 89.9697 30.6594 89.7158 30.6594H81.7361V23H89.7158C89.9696 23.0004 90.2129 23.1015 90.3924 23.281C90.5719 23.4605 90.673 23.7038 90.6734 23.9576V23.9576Z",
    stroke: "#579EE5",
    strokeWidth: 0.638962,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8203 25.3936H69.1279V28.2664H79.8203V25.3936Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3729 28.4258H64.5",
    stroke: "#579EE5",
    strokeWidth: 0.638962,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3729 26.8306H64.5",
    stroke: "#579EE5",
    strokeWidth: 0.638962,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3729 25.2339H64.5",
    stroke: "#579EE5",
    strokeWidth: 0.638962,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M100.221 41.8145H79.8806V62.1552H100.221V41.8145Z",
    fill: "#DFF3FA"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M100.221 41.8145H97.51V62.1552H100.221V41.8145Z",
    fill: "#579EE5"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M100.221 41.8145H79.8806V62.1552H100.221V41.8145Z",
    stroke: "#579EE5",
    strokeWidth: 1.35744,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4793 51.9861L85.9842 56.7319V47.2402L95.4793 51.9861Z",
    fill: "#90C1F3"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3408 41.8145H49V62.1552H69.3408V41.8145Z",
    fill: "#DFF3FA"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3401 41.8145H66.6287V62.1552H69.3401V41.8145Z",
    fill: "#579EE5"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3408 41.8145H49V62.1552H69.3408V41.8145Z",
    stroke: "#579EE5",
    strokeWidth: 1.35744,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1026 59.1067C56.4141 59.1067 57.4773 58.0436 57.4773 56.7321C57.4773 55.4206 56.4141 54.3574 55.1026 54.3574C53.7911 54.3574 52.728 55.4206 52.728 56.7321C52.728 58.0436 53.7911 59.1067 55.1026 59.1067Z",
    fill: "#90C1F3"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5441 57.0721C62.8556 57.0721 63.9188 56.0089 63.9188 54.6974C63.9188 53.3859 62.8556 52.3228 61.5441 52.3228C60.2327 52.3228 59.1695 53.3859 59.1695 54.6974C59.1695 56.0089 60.2327 57.0721 61.5441 57.0721Z",
    fill: "#90C1F3"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7959 56.7321V48.5944L63.2394 46.5635V54.6977",
    stroke: "#90C1F3",
    strokeWidth: 1.35744,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipDefault);
export default __webpack_public_path__ + "static/media/clip_default.6db76d49b52cb166f3e2b56e4e596b22.svg";
export { ForwardRef as ReactComponent };